'use client'

import { cn } from '../../utils/cn'

export interface AvatarStackProps {
  avatars: string[]
  max?: number
  size?: 'sm' | 'md' | 'lg'
}

const sizeClasses = {
  sm: 'w-6 h-6 text-xs -space-x-1.5',
  md: 'w-8 h-8 text-sm -space-x-2',
  lg: 'w-10 h-10 text-base -space-x-2.5',
}

const avatarSizes = {
  sm: 'w-6 h-6',
  md: 'w-8 h-8',
  lg: 'w-10 h-10',
}

export function AvatarStack({
  avatars,
  max = 5,
  size = 'md'
}: AvatarStackProps) {
  const visibleAvatars = avatars.slice(0, max)
  const remaining = avatars.length - max

  return (
    <div className={cn('flex items-center', sizeClasses[size].split(' ').slice(2).join(' '))}>
      {visibleAvatars.map((avatar, index) => (
        <img
          key={index}
          src={avatar}
          alt=""
          className={cn(
            avatarSizes[size],
            'rounded-full border-2 border-[var(--landing-bg)]',
            'ring-1 ring-[var(--landing-border)]'
          )}
        />
      ))}
      {remaining > 0 && (
        <div
          className={cn(
            avatarSizes[size],
            'rounded-full border-2 border-[var(--landing-bg)]',
            'ring-1 ring-[var(--landing-border)]',
            'bg-[var(--landing-bg-card)]',
            'flex items-center justify-center',
            'text-[var(--landing-text-muted)] font-medium',
            size === 'sm' ? 'text-[10px]' : size === 'md' ? 'text-xs' : 'text-sm'
          )}
        >
          +{remaining > 99 ? '99' : remaining}
        </div>
      )}
    </div>
  )
}
